import { db } from './firebaseConfig';
import { ref, set } from 'firebase/database';
import { generateId } from './idGenerator';

/**
 * Persists an administrative action to the Realtime Database Audit Logs.
 * 
 * @param {string} adminId The AID-DVT-XXXXXX identifier from the userProfile
 * @param {string} action A short description of the action (e.g. "Deleted User")
 * @param {string} target The identifier of the modified object (e.g. "user123" or "global_settings")
 */
export const logAdminAction = async (adminId, action, target) => {
  if (!adminId) return; // Fail silently if not logged in properly

  try {
    const logId = await generateId('LOG');
    const newLogRef = ref(db, `adminLogs/${logId}`);
    
    await set(newLogRef, {
      logId: logId,
      adminId: adminId,
      action: action,
      target: target,
      timestamp: Date.now()
    });
  } catch (error) {
    console.error("Critical Failure: Unable to write to Audit Log", error);
  }
};
